import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  ConversationsResponseDataSchema,
  DataResponseWithPagination,
  GetConversationsSchema,
} from "schema"
import { z } from "zod"

type Query = z.input<typeof GetConversationsSchema>
type Response = DataResponseWithPagination<z.infer<typeof ConversationsResponseDataSchema>>
type Options = {
  refetchInterval?: number
  enabled?: boolean
  onSuccess?: (data: Response) => void
}

export const getConversationsQueryKey = (query?: Query) => ["conversations", query].filter(Boolean)

type Props = {
  query?: Query
  onSuccess?: (data: Response) => void
  options?: Options
}

export const conversationsQuery = ({ query, onSuccess, options }: Props = {}) => {
  return queryOptions({
    queryKey: getConversationsQueryKey(query),
    queryFn: async () => {
      const response = await axios.get<Response>("/conversations", { params: query })

      onSuccess?.(response.data)

      return response.data
    },
    refetchInterval: options?.refetchInterval,
    enabled: options?.enabled,
  })
}
